var map = {
	"./screen1.jpg": 42,
	"./screen2.jpg": 43,
	"./screen3.jpg": 44,
	"./screen4.jpg": 45,
	"./screen5.jpg": 46,
	"./screen6.jpg": 47,
	"./screen7.jpg": 48,
	"./screen8.jpg": 49,
	"./screen9.jpg": 50
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41;